import { SvgProps } from "./types";
import Svg from "./Svg";

const PointsIcon = (props: SvgProps) => {
  const { color } = props;

  return (
    <Svg
      width="14"
      height="13"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.40193 1.5C3.55663 -0.500002 6.44338 -0.5 7.59808 1.5L9.33013 4.5C10.4848 6.5 9.04145 9 6.73205 9H3.26795C0.958546 9 -0.484827 6.5 0.669873 4.5L2.40193 1.5Z"
        fill={color || "#EDEDED"}
      />
    </Svg>
  );
};

export default PointsIcon;
